module.exports = __webpack_public_path__ + "static/media/child_smile.69b3fc07.png";